import {addDays, format, startOfWeek, subDays} from 'date-fns';
import { useMemo } from "react"
import { useMachineEfficiency } from "../scripts/queries/usePlantReportQueries";
import { usePlantFilters, searchRows, usePlantTable, sortedRows, exportPlantTables } from "./usePlantTable";

const EMPTY_ARRAY = [];
const WEEK_DAYS = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
//Zobele block
const ZOBELE_MACHINES = ['MARK ANDYZ', 'MARKANDYZ2'];

//The efficiency of each machine per day of the week of yesterday and its weekly average.
export const useMachineEfficiencyNormalizer = (active = true) => {
    const mondayKey = format(startOfWeek(subDays(new Date(), 1), {weekStartsOn: 1}), 'yyyy-MM-dd');

    const {search, sorting, setSearch, setSorting} = usePlantFilters('MACHINE_EFFICIENCY_FILTERS');
    const {data = EMPTY_ARRAY, refetch: fetchData, isFetching, isLoading: loading} = useMachineEfficiency(active);

    const days = useMemo(() => WEEK_DAYS.map((label, i) => {
        const day = addDays(new Date(`${mondayKey}T00:00:00`), i);
        return {key: format(day, 'yyyy-MM-dd'), header: `${label} ${format(day, 'dd')}`};
    }), [mondayKey]);

    //The average ignores the days the machine didn't produce
    const rows = useMemo(() => data.map(machine => {
        const values = days.map(day => machine.dias[day.key] ?? null);
        const present = values.filter(value => value != null);
        return {
            maquina: machine.maquina,
            ...Object.fromEntries(values.map((value, i) => [`dia${i}`, value])),
            promedio: present.length ? present.reduce((sum, value) => sum + value, 0) / present.length : null,
        };
    }), [data, days]);

    const filteredRows = useMemo(() => searchRows(rows, search, ['maquina']), [rows, search]);
    const mainData = useMemo(() => filteredRows.filter(row => !ZOBELE_MACHINES.includes(row.maquina)), [filteredRows]);
    const zobeleData = useMemo(() => filteredRows.filter(row => ZOBELE_MACHINES.includes(row.maquina)), [filteredRows]);

    const columnDefs = useMemo(() => [
        {accessorKey: 'maquina', header: 'Máquina', type: 'text', width: 220},
        ...days.map((day, i) => ({accessorKey: `dia${i}`, header: day.header, type: 'pct'})),
        {accessorKey: 'promedio', header: 'Promedio semanal', type: 'pct', width: 170},
    ], [days]);
    const {columns, table} = usePlantTable(columnDefs, mainData, sorting, setSorting);
    const {table: zobeleTable} = usePlantTable(columnDefs, zobeleData, sorting, setSorting);

    const exportCSV = () => exportPlantTables(`Reporte_Eficiencia_Maquina_${days[0].key}.xlsx`, [
        {columns, rows: sortedRows(table)},
        ...(zobeleData.length ? [{columns, title: 'ZOBELE', rows: sortedRows(zobeleTable)}] : []),
    ]);

    return {table, extraTables: [{table: zobeleTable, title: 'ZOBELE'}], loading, isFetching, search, setSearch, fetchData, exportCSV};
}